import React from 'react'
import { ChainId, Currency, Token } from '@nominex/nomiswap-sdk'
import { Text } from '@nominex/dex-uikit'
import tw from 'twin.macro'
import styled from 'styled-components'

import { useTranslation } from 'contexts/Localization'
import { SUGGESTED_BASES } from 'config/constants/exchange'
import { AutoColumn, AutoRow } from 'components/Layout'
import QuestionHelper from 'components/QuestionHelper'
import { CurrencyImage } from 'components/CurrencyImage'
import useNativeCurrency from 'hooks/useNativeCurrency'

const BaseWrapper = styled.div<{ disable?: boolean }>`
  ${tw`flex gap-8 border rounded-12 p-8 items-center bg-dark-gray-700`}
  ${({ disable }) =>
    disable ? tw`border-transparent opacity-40` : tw`border-dark-gray-600 hover:cursor-pointer hover:bg-dark-gray-400`};
`

export default function CommonBases({
  chainId,
  onSelect,
  selectedCurrency,
  allowedTokens = [],
  unallowedTokens = [],
}: {
  chainId?: ChainId
  selectedCurrency?: Currency | null
  onSelect: (currency: Currency) => void
  allowedTokens: string[]
  unallowedTokens: string[]
}) {
  const { t } = useTranslation()
  const native = useNativeCurrency()

  return (
    <AutoColumn gap="md">
      <AutoRow>
        <Text fontSize="14px">{t('Common bases')}</Text>
        <QuestionHelper content={t('These tokens are commonly paired with other tokens.')} />
      </AutoRow>
      <AutoRow gap="auto">
        <BaseWrapper
          onClick={() => {
            if (!selectedCurrency || !selectedCurrency.isNative) {
              onSelect(native)
            }
          }}
          disable={selectedCurrency?.isNative}
        >
          <CurrencyImage currency={native} size="18px" />
          <Text>{native?.symbol}</Text>
        </BaseWrapper>
        {(chainId ? SUGGESTED_BASES[chainId] : [])
          .filter((token: Token) => (allowedTokens.length ? allowedTokens.includes(token.address) : true))
          .filter((token: Token) => !unallowedTokens.includes(token.address))
          .map((token: Token) => {
            const selected = selectedCurrency?.equals(token)
            return (
              <BaseWrapper onClick={() => !selected && onSelect(token)} disable={selected} key={token.address}>
                <CurrencyImage currency={token} size="18px" />
                <Text noTranslate>{token.symbol}</Text>
              </BaseWrapper>
            )
          })}
      </AutoRow>
    </AutoColumn>
  )
}
